import React, { createContext, useContext } from "react";
import { ChildrenProps } from "../reactExt";

const Context = createContext<React.ReactNode>(null);

type ProviderProps = ChildrenProps & {
  outlet: React.ReactNode;
};

// Passes the outlet to the `ChildrenOutlet`s below.
export const ChildrenOutletProvider: React.FC<ProviderProps> = (props) => {
  const { children, outlet } = props;

  return <Context.Provider value={outlet}>{children}</Context.Provider>;
};

// Renders the outlet of the nearest `ChildrenOutletProvider`.
//
// Its type stays the same as the outlet changes, so a guard that renders it
// as the component for a state keeps the outlet mounted, while a component
// created from the children would remount them on every change.
export const ChildrenOutlet: React.FC = () => <>{useContext(Context)}</>;
